import { injectIntl } from 'react-intl';

import ElectronicServices from './ElectronicServices';

export default injectIntl(ElectronicServices);
